export default __webpack_public_path__ + "static/media/defaultImg.bf5482a4.jpeg";